import { useParkingStore } from '@illegally-parked/store/store';

type Props = {
  title: string;
};

export const SelectedLocationTextContent = ({ title }: Props) => {
  const { serviceLocationDetails } = useParkingStore();
  return (
    serviceLocationDetails.full_address && (
      <div className="text-bodyXl mt-4 flex flex-col gap-[1.25rem]">
        <p className="font-semibold text-black">{title}</p>
        <p className="font-normal text-black">
          {serviceLocationDetails.full_address}
        </p>
      </div>
    )
  );
};
